const ORDER = "/order";

export const GET_PREVIOUS_ORDERS = `${ORDER}/getAllMechanicPreviousOrders`;

export const GET_PREVIOUS_VOICE_ORDERS = `${ORDER}/getAllMechanicPreviousVoiceOrders`;

export const CREATE_ORDER = `${ORDER}/createOrderForMechanicApp`;

export const CREATE_VOICE_ORDER = `${ORDER}/createVoiceOrder`;

export const CHECK_MECHANIC_HAS_PENDING_ORDERS = `${ORDER}/checkMechanicHasPendingOrders`;

export const CHECK_MECHANIC_HAS_PRICING_DONE_ORDERS = `${ORDER}/checkMechanicHasPricingDoneOrders`;

export const GET_PENDING_ORDERS = `${ORDER}/getAllMechanicPendingOrders`;

export const GET_PRICED_ORDERS = `${ORDER}/getAllMechanicPricingDoneOrders`;

export const GET_PRICED_ORDER_ITEMS = `${ORDER}/getAllOrderItemsForPricingDoneOrder/:orderId`;

export const GET_ORDER_ITEM_PRICES = `${ORDER}/getAllOrderItemPricingList/:itemId`;

export const ACCEPT_ORDER_PRICING = `${ORDER}/acceptOrderFromMechanicApp`;

export const REJECT_ORDER_PRICING = `${ORDER}/rejectOrderPricingForMechanicApp`;

export const GET_DELIVERY_SLOTS = `${ORDER}/getDeliverySlots/v2`;
